module.exports = __webpack_public_path__ + "static/media/al.46612c27.svg";